export default __webpack_public_path__ + "static/media/ContractChange.b28fc943.svg";